import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import * as plugins from '../plugins'
import { PAGE_BUILDER_SELECTION_TARGET, type TypeParams } from '../types'

/**
 * Triggers a widget preview when a page is being edited in the Page Builder.
 *
 * This effect listens for the `preview` action and initiates
 * a widget preview request. It's used to ensure that the appropriate widget
 * preview is shown in the UI while the user is editing a page.
 */
export const triggerWidgetPreviewOnPageBuilderEdit = store.effects.create(
  (feature: ec.Collection<TypeParams>['feature'], widgetEc: Collection) =>
    widgetEc.plugins.selectionPlugin.feature.selectors
      .getFirstSelectedId({ target: PAGE_BUILDER_SELECTION_TARGET })
      .asObservable.pipe(
        rxjs.filter(TypeChecker.isNotNullish.raw),
        rxjs.map(alias =>
          widgetEc.plugins
            .lookup(plugins.preview.Plugin)
            .get()
            .feature.actions.preview.from(
              'triggerWidgetPreviewOnPageBuilderEdit (effect)',
            )
            .create({
              flexibleIdentifier: { alias },
            }),
        ),
      ),
)
